// Статусы заявки на вступление в команду проекта
export const STATUS_NEW = 1;
export const STATUS_APPROVED = 2;
export const STATUS_REJECTED = 3;